import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import { LoadableLazy } from '@confluence/loadable';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConfluenceConversationAssistantBundle',
	});
};

export const ConfluenceConversationAssistant = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConversationAssistant" */ '../src/main'))
			.ConfluenceConversationAssistant,
	loading: createLoadingComponent,
});
